import {
  ArrowDownRight01Icon,
  ArrowUpRight01Icon,
} from "@hugeicons-pro/core-stroke-rounded";

export type GameRtpTrend = "hot" | "cold" | "neutral";

const TREND_ICONS = {
  hot: ArrowUpRight01Icon,
  cold: ArrowDownRight01Icon,
  neutral: undefined,
} as const satisfies Record<
  GameRtpTrend,
  typeof ArrowUpRight01Icon | undefined
>;

const computeRtpTrend = (
  rtp?: number | null,
  rtpLive?: number | null,
): GameRtpTrend => {
  if (typeof rtp !== "number" || typeof rtpLive !== "number") {
    return "neutral";
  }
  if (rtp > rtpLive) {
    return "cold";
  }
  if (rtp < rtpLive) {
    return "hot";
  }
  return "neutral";
};

export { TREND_ICONS };
export default computeRtpTrend;
